<form [formGroup]="form">
  <mat-dialog-content>
    <sn-canvas *ngIf="canvas" [(canvas)]="canvas"></sn-canvas>
    <form>
      <mat-form-field appearance="fill">
        <mat-label>{{ 'map.telestration.name' | t }}</mat-label>
        <input
          matInput
          [placeholder]="'map.telestration.name' | t"
          [(ngModel)]="telestrationTitle"
          name="telestrationTitle"
        />
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button mat-button *ngIf="canvas" (click)="saveToVault()" [mtBasicSpinner]="loading">
      {{ 'map.actions.saveToVault' | t }}
    </button>
    <button mat-button *ngIf="canvas" (click)="download()">{{ 'common.download' | t }}</button>
    <ng-container *ngIf="canvas && canSend()">
      <button
        mat-button
        *ngIf="!data?.id; else shareMenuTmpl"
        [mtBasicSpinner]="isSending"
        (click)="share()"
      >
        {{ 'common.share' | t }}
      </button>
      <ng-template #shareMenuTmpl>
        <button mat-button [mtBasicSpinner]="isSending" [matMenuTriggerFor]="shareMenu">
          {{ 'common.share' | t }}
        </button>
        <mat-menu #shareMenu="matMenu">
          <button mat-menu-item (click)="share()">
            <span>{{ 'map.telestration.selectChannel' | t }}</span>
          </button>
          <button mat-menu-item (click)="shareToSame()">
            <span>{{ 'map.telestration.shareToSameChannel' | t }}</span>
          </button>
        </mat-menu>
      </ng-template>
    </ng-container>
  </mat-dialog-actions>
</form>
